module.exports = __webpack_public_path__ + "static/media/swash.23d4c91b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/swash.svg
// module id = 163
// module chunks = 0